// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IPreferredDto
 */
export interface IPreferredDto {
    /**
     * 
     * @type {boolean}
     * @memberof IPreferredDto
     */
    preferred: boolean;
    /**
     * 
     * @type {Date}
     * @memberof IPreferredDto
     */
    valid_from?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof IPreferredDto
     */
    valid_to?: Date | null;
}

/**
 * Check if a given object implements the IPreferredDto interface.
 */
export function instanceOfIPreferredDto(value: object): value is IPreferredDto {
    if (!('preferred' in value) || value['preferred'] === undefined) return false;
    return true;
}

export function IPreferredDtoFromJSON(json: any): IPreferredDto {
    return IPreferredDtoFromJSONTyped(json, false);
}

export function IPreferredDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IPreferredDto {
    if (json == null) {
        return json;
    }
    return {
        
        'preferred': json['preferred'],
        'valid_from': json['valid_from'] == null ? undefined : (new Date(json['valid_from'])),
        'valid_to': json['valid_to'] == null ? undefined : (new Date(json['valid_to'])),
    };
}

export function IPreferredDtoToJSON(json: any): IPreferredDto {
    return IPreferredDtoToJSONTyped(json, false);
}

export function IPreferredDtoToJSONTyped(value?: IPreferredDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'preferred': value['preferred'],
        'valid_from': value['valid_from'] === null ? null : ((value['valid_from'] as any)?.toISOString()),
        'valid_to': value['valid_to'] === null ? null : ((value['valid_to'] as any)?.toISOString()),
    };
}

